export const DEFAULT_GENERAL_SETTINGS: API.GeneralSettings = {
  logoUrl: '',
  platformName: '',
  footerText: '',
};
